import { Catalogos } from "../../services/Catalogos";
import { useForm, UseFormProps } from "../../hooks/useForm";
import { useState, useRef, useEffect } from "react";
import { Helper } from "../../helper/Helper";
import { ICVService } from "../../services/ICVService";

import ReactDOM from 'react-dom/client';

import { Modal } from "../modal/ModalPage";
import { ICVUtils } from "./ICVUtils";




import DatePicker, { DateObject, DatePickerRef  } from "react-multi-date-picker"
import  DatePanel    from "react-multi-date-picker/plugins/date_panel"
//import  gregorian from "react-date-object/calendars/gregorian";
//import  gregorian from "../../api/calendar/gregorian";
//import  gregorian_es from "react-date-object/locales/gregorian_es";
//import  gregorian_bi from "react-date-object/locales/gregorian_bi";
import  gregorian_es from "../../api/locale/gregorian_es";
//import  gregorian_bi from "../../api/locale/gregorian_bi";
import Footer from "react-multi-date-picker/plugins/range_picker_footer";
import transition from "react-element-popper/animations/transition"
import InputIcon from "react-multi-date-picker/components/input_icon"
import "react-multi-date-picker/styles/layouts/prime.css"




import '../../css/stylesmsvs.css'
import { RefObject } from "react";
//import { argv0 } from "process";



export class TabICVForm implements UseFormProps {
	
    rutaTematica:string='';
    rutaTematicaMes:string='';

    ID_TIPO_PRDO:string='';
    ID_TIPO_LNEA:string='';
    ID_CLSN_VVNA:string='';
    ID_NVEL_INGO:string='';
    ID_GRPO_EDAD:string='';
    CV_ENTD_FDRA:string='';
    ID_TIPO_CRDO:string='';

    ID_RNGO_ECVEICV:string='';

    SELECT_PERIODO_ECUVE:string='';

    ID_INTS_IDG:string='';
    ID_RGIN_BCLA:string='';
    ID_TPLA_VVNA:string='';

    metricas   : string = '';    
    dimensiones: string = '';
    indicador  : string = '';
    
    
    periodo_anio_inicio:string = '' ;
    periodo_anio_fin:string = '' ;
    periodo_mes_inicio:string = '' ;
    periodo_mes_fin:string = '' ;
    
    periodo_calendario:string = '' ;
    
    rangoCalendar:any[]=[null, null]
    
}

export const TabICV = () => {
    
    const { elementos, reset, updateAttVal, handleChangeEvent, handleClickEvent }= useForm<TabICVForm>(new TabICVForm() );

    const { rutaTematica } = elementos;
    
    const [ error, setError ] = useState<string>('');
    const [ toggle, setToggle ] = useState(false);
    
    const refBtnGenDescICV = useRef<HTMLButtonElement>(null);

    const ahref = useRef<HTMLAnchorElement>(null);
    
    const btnReset          = useRef<HTMLButtonElement>(null);
    const divCollapse       = useRef<HTMLDivElement>(null);
    const divCollapseMtcs   = useRef<HTMLDivElement>(null);

    const [ descargando, setDescargando ] = useState<boolean>(false) ;
    const [ fileReady, setFileReady ] = useState<boolean>(false) ;

    const maxDimnsPermitidas = 4;

    const utils = new ICVUtils();
    
    
    const [ toggleUseEffect, setToggleUseEffect ] = useState(false); // Forzar lanzar useEffect si es true
    
    ////////////////////////    
    
    //const txtCalendar          = useRef<RefObject>(null);
    const calendarRef = useRef();
    //const calendarRef = useRef<DatePickerRef>();
    
    const [valueCal, setValueCal] = useState("");
    //const [valsCal, setValsCal] = useState({date:DateObject});
    //const [valsCal, setValsCal] = useState({calendar:new DateObject()});
    const [propsCalendar, setPropsCalendar] = useState({isValid:false, aIni:"", mIni:"", aFin:"", mFin:""});
    
    ////////////////////////
    
    
    
    
    
    useEffect(() => {
        //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>useEffect()   desde useEffect     Error: [' + error + "]   toggle: [" + toggle + "]");
        
      
	 if(error !=='') {
            setToggle(false);
            setError("");
     }
        
        return () => {
            /* cuerpo cuando se desmonta */
        }
    }, [error,elementos, toggleUseEffect]);
    
    
    
    const reset2 = () => {
		reset();
		/*
        reset();
        if (divCollapse.current && divCollapse.current.className) {
            divCollapse.current.className = 'collapse hide';
        }

        setDescargando(false);
        */
	   
	   
	   setDescargando(false) ;
       setFileReady(false) ;
       setError('')
        
       setToggleUseEffect( true );
	   
	   	utils.resetICV();
	   	
	   	refBtnGenDescICV.current!.disabled = false;
	   	
	   	
    }
    
    const nuevaConsulta = () => {
		reset2();
		
		
     	divCollapse.current!.className = 'collapse hide';
         	
         	
         //Muestra u oculta la sección de métricas (collapse)
        //if (divCollapseMtcs.current)
            divCollapseMtcs.current!.className = 'collapse hide';
        
		
		setDescargando(false);
		setFileReady(false);
		//if ( refBtnGenDescICV && refBtnGenDescICV.current ) 
			refBtnGenDescICV.current!.disabled = false ;
			
		//setValueCal("");
		setPropsCalendar({isValid:false, aIni:"", mIni:"", aFin:"", mFin:""});
		
		/*
		console.log("CLEAN");
		console.log(calendarRef.current!["date"]);
		console.log(calendarRef.current!["value"]);console.log("Atributos:::::");
			console.log(calendarRef.current!["childNodes"]);
			console.log(calendarRef.current!["childNodes"][0]["childNodes"][0]["childNodes"][0]["value"]); //->Attributes
			//calendarRef.current!["childNodes"][0]["childNodes"][0]["childNodes"][0]["value"] = null	;
			console.log(calendarRef.current!["childNodes"][0]["childNodes"][0]["childNodes"][0]["value"]); //->Attributes
			//console.log(calendarRef.current!["childNodes"][0]["childNodes"][0]["innerHTML"]); //->Attributes
			//console.log(calendarRef.current!.toString());
		*/
	}

    const handleRadioClick = (clickEvent:React.MouseEvent<HTMLInputElement>) => {
        handleClickEvent( clickEvent );
        //console.log('handleRadioClick')
        const target = clickEvent.currentTarget;

        //console.log('Click: ' + target.value);

        if ( rutaTematica !== target.value ) {
            btnReset.current?.click();
            updateAttVal(target.name, target.value);
            target.checked = true;
        }

        if (divCollapse.current && divCollapse.current.className) {
            divCollapse.current.className = 'collapse ';
        }
        
    }


    const handleDimensionesClick = (clickEvent:React.MouseEvent<HTMLInputElement>) => {
        handleClickEvent( clickEvent );
        
        
        const target = clickEvent.currentTarget;

        console.log('Click: ' + target.value);


        //Muestra u oculta la sección de métricas (collapse)
        if (divCollapseMtcs.current)
            divCollapseMtcs.current.className = utils.showMetricasClass();
        

        //Habilita o inhabilita los checks de las dimensiones
        utils.habilitaChecks('queryDmns', maxDimnsPermitidas);    

        //Habilita o inhabilita el Mes
        utils.habilitaMes();

        
        let divMetricas : HTMLDivElement | null = document.querySelector("#collapse-ECUVE-mtcs");
        //let myContainer = document.querySelector("#collapse-ECUVE-mtcs");
        //myContainer?.innerHTML = 'utils.xx()';
        //myContainer!.innerHTML = 'utils.xx()';
        //myContainer.innerHTML = utils.xx();
        
        
        const rootDivMetricas = ReactDOM.createRoot(divMetricas!);
        rootDivMetricas.render(utils.showMetricas(elementos.rutaTematica));
        
        //ReactDOM.render(utils.createMetricasECUVE(), document.querySelector("#collapse-ECUVE-mtcs"));
     
     	
    }


	
	
    const handleSubmit = async () => {
		

		
		let res = utils.validaForm(elementos, propsCalendar.isValid);
		
		
		
		if(res !== ''){
			setError(res);
			setToggle(true);
			//console.log("Res::  [" + res  + "]   Error: [" + error + "]   toggle: [" + toggle + "]");
			return;	
		}
		
			

        const icvServ = new ICVService() ;
        
        console.log( elementos );
        console.log( "Ejecutando servicios    " + process.env.REACT_APP_CONTEXT_PATH_REST);
       
        setDescargando(true) ;
        setFileReady(false) ;


       
        
        
        let dimensiones:string='dims=' + utils.getDimensionesSeleccionadas();
        
        console.log("Dimensiones: " + dimensiones);

        //let metricas:string='mtrs=R27_01,R27_02';        
        let metricas:string = 'mtrs=' + utils.getMetricasSeleccionadas();
		
        
        
        
        let periodo:string = Helper.getPeriodoTxt(propsCalendar);
        /*let periodo:string = 'per=' + elementos.periodo_anio_inicio + "," + elementos.periodo_mes_inicio + "," +
                             elementos.periodo_anio_fin + "," + elementos.periodo_mes_fin;*/
		
        
        let tipoIndicador:string = ''

        if(elementos.rutaTematica=="ecuve")
            tipoIndicador='tipo=CICV_ECUVE';
        else
        tipoIndicador='tipo=CICV_SISEVIVE';

        
           
		
        /* */
        
        let params = dimensiones + "&" + metricas + "&" + periodo + "&" + tipoIndicador;
        console.log("params: " + params);

        //const url = process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?dims=CV_ENTD_FDRA,ID_NVEL_INGO,ID_CLSN_VVNA,ID_TIPO_CRDO&mtrs=R27_02,R27_01&mes=ID_MES&per=2023&tipo=CICV_SISEVIVE';
        const url = process.env.REACT_APP_CONTEXT_PATH_REST + '/procesaFicheroRest?' + params;

        console.log(url);

        	    refBtnGenDescICV.current!.disabled = true ;
		
		
        await icvServ.consultaICV( params )
            .then( (data: BlobPart) =>{
                
                if( data ) {
                    setFileReady(true) ;
                    setDescargando(false) ;
                    if( ahref && ahref.current ) {
                        ahref.current.className = '' ;
                        ahref.current.download = Helper.getFileNameExt( 'Masivos_ICV', 'txt') ;
                        ahref.current.target = '_blank' ;
                        ahref.current.href = URL.createObjectURL( new Blob( [ data ], { type: 'text/plain' } ) ) ;
                        ahref.current.click();
                    }
                } else {
                    console.error("No se genero data/blob.")
                    setDescargando(false) ;
                    //setError('Ocurrio algún error al generar el archivo.');
                }
            }).catch((e: any) => {
                setDescargando(false) ;
                //setError(e.message);
                /*if ( refBtnGenDesc && refBtnGenDesc.current ) {
                    refBtnGenDesc.current.disabled = false ;
                }*/
        });

        /* */


		
		
		
		
        
    }
    
    
    
    
    
    return (
        <div className="row" id="accordion">
            <form className="col-12">
            <div className="col-12 mt-4">
                <div className="row">
                    <div className="offset-10  mt-12">
                        <button type="reset" className="btn button-rojo btn-rojo  mt-3 mt-md-0  btnClean" onClick={ reset2 } ref={ btnReset } >Limpiar consulta</button>
                    </div>
                    
                </div>
                <div className="row">
                    <div className="col-12 m-2">
                        <p className="bold negro">Selecciona la ruta temática</p>
                        <div className="custom-control custom-radio">
                            <input type="radio"
                                name="rutaTematica"
                                id='ecuve'
                                value='ecuve'
                                className="custom-control-input"
                                data-toggle="collapse"
                                data-target="#collapse-ECUVE"
                                role="button"
                                onClick={ handleRadioClick }
                                />
                            <label className="custom-control-label" htmlFor='ecuve' >ECUVE</label>
                        </div>
                        <div className="custom-control custom-radio">
                            <input type="radio" 
                                name="rutaTematica"
                                id='sisevive'
                                value='sisevive'
                                className="custom-control-input"
                                data-toggle="collapse"
                                data-target="#collapse-ECUVE"
                                role="button"
                                onClick={ handleRadioClick }
                                />
                            <label className="custom-control-label" htmlFor='sisevive' >SISEVIVE</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 mt-1">
                <hr></hr>
                <div className="row">
                    <div className="col-12 mt-1">
                        
                        <div id="collapse-ECUVE" className="collapse" aria-labelledby="ecuve" data-parent="#accordion" ref={ divCollapse } >
                            <div className="card-body">
                                <div className="card border-0">
                                    <div className="card-header fondo-blanco border-0" >
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="bold negro">Selecciona un subtema</p>
                                                <p className="info-cubos bold negro">Se pueden seleccionar hasta 4 variables y "mes" como opción de visualización adicional</p>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <p className="bold negro ml-2">Variables generales</p>
                                                        {
                                                            Catalogos.CAT_VARIABLES_ECUVE_SISEVIVE.json.map( (item,i) =>{ return (
                                                                <div key={ item.Id + i } className="custom-control custom-checkbox">
                                                                    <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.Id }
                                                                        className="custom-control-input queryDmns"
                                                                        onClick={ handleDimensionesClick }
                                                                        />
                                                                    <label className="custom-control-label" htmlFor={ item.Id } >{ item.Tx }</label>
                                                                </div> ) })
                                                        }
                                                        <div className="custom-control custom-checkbox">
                                                            <input type="checkbox" name="rutaTematicaMes" value="mes" className="custom-control-input queryDmnsMes" id='rutaTematicaMes'  disabled/>
                                                            <label className="custom-control-label" htmlFor='rutaTematicaMes' >Mes</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-6">
                                                        { rutaTematica === 'ecuve' &&
                                                        <div className="custom-control custom-checkbox" >
                                                            <p className="bold negro ml-2">Variables únicas ECUVE 2.0</p>
                                                            <input type="checkbox" name="ID_RNGO_ECVEICV" value="ID_RNGO_ECVE" className="custom-control-input queryDmns" id='ID_RNGO_ECVEICV' onClick={ handleDimensionesClick } />
                                                            <label className="custom-control-label" htmlFor='ID_RNGO_ECVEICV' >Rango de Ecuve 2.0</label>
                                                        </div>
                                                        }
                                                        { rutaTematica === 'sisevive' &&
                                                        <div className="custom-control custom-checkbox" >
                                                            <p className="bold negro ml-2">Variables únicas SISEVIVE</p>
                                                            {
                                                                Catalogos.CAT_VARIABLES_SISEVIVE.json.map( (item,i) =>{ return (
                                                                    <div key={ item.Id + i } className="custom-control custom-checkbox">
                                                                        <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.Id }
                                                                            className="custom-control-input  queryDmns"
                                                                            onClick={ handleDimensionesClick }
                                                                            />
                                                                        <label className="custom-control-label" htmlFor={ item.Id } >{ item.Tx }</label>
                                                                    </div> ) })
                                                            }
                                                        </div>
                                                        }
                                                        

                                                        {/** Periodo anterior */}


                                                    </div>
                                                </div>

                                                




                                                <div className="row form-group mt-4">
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <hr></hr>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <p className="bold negro">Periodo</p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            

                                                       			<DatePicker
                                                       				render={<InputIcon
                                                       							placeholder="Seleccione un rango de fechas"
                                                       							className="custom-input-per"         
                                                       						/>
                                                       						}
                                                       				onlyMonthPicker
																  	range
																  	//locale={Gregorian_es}
																  	//calendar={gregorian}
																  	locale={gregorian_es}
																  	//headerOrder={["MONTH_YEAR", "LEFT_BUTTON", "RIGHT_BUTTON"]} 
																  	plugins={[
																	    <DatePanel header="Selección"
																	    		placeholder="Fechas seleccionadas"
																	    		className="panelDerecho"
																	    		
																	      />,
																	    <Footer position="bottom"
																	    		format="MMM YYYY"
																	    		names={{
																			        selectedDates: "Rango seleccionado",
																			        from: "Ini:",
																			        to: "Fin:",
																			        selectDate: "-",
																			        close: "Aceptar",
																			        separator: ",",
																		     	}}
																	     />
																	  ]}
																	  
																	/*animations={[
																        transition({
																          from: 35,
																          transition: "all 800ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
																    }),]}*/
																    //animations={[transition()]}  
																	  
																	dateSeparator="   a   "
																	minDate={new Date('2011-01-01')}
																	maxDate={new Date()}
																	
																	format="MMMM YYYY"
																	//numberOfMonths={2}
																	title="Seleccione el rango de búsqueda"
																	required
																	//id="calPeriodoId"
																	inputClass="custom-input-per"
																	editable={false}
																	placeholder="Seleccione un rango de fechas"
																	hideOnScroll
																	onChange={(date:DateObject[]) => { 																			
																			
																			let periodo = {isValid:false, aIni:"", mIni:"", aFin:"", mFin:""}
																			
																			periodo.aIni = "" + date[0]?.year;
																			periodo.aFin = "" + date[1]?.year;  
																			
																			periodo.mIni = "" + (date[0]?.monthIndex+1);
																			periodo.mFin = "" + (date[1]?.monthIndex+1);
																			
																			if(date.length==2)
																				periodo.isValid = true
																																							
																			
																			setPropsCalendar(periodo);
																		}																			
																	}
																	
																	onOpen={ () => {
																		/*console.log("Opeeeeeeeeeeeeeeeeeeen");
																		console.log(this);*/
																	}																																				
																	}
																	ref={calendarRef}
																	value={ elementos.rangoCalendar }
																	
																>
																</DatePicker>

                                                        </div>
                                                </div>
                                            
                                            
                                            
                                            
                                            </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        

                    </div>
                </div>

                <hr></hr>

				 

                <div className="row">
                    <div className="col-12 mt-1">
                        <div id="collapse-ECUVE-mtcs" className="collapse" aria-labelledby="ecuve" data-parent="#accordion" ref={ divCollapseMtcs } >
                            -----
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4 text-center">
                        {
                            descargando &&
                            <span>
                                <img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descargando-animado.gif'} className="imgGif" />
                                <br></br>
                                <span style={{fontSize:'36px'}} >
                                    Ejecutando <span className="text-danger">Descarga</span>
                                </span>
                            </span>

                        }
                        <br></br>
                        <a ref={ ahref } href="#" className={ fileReady ? '':'oculta'} onClick={ () => { ahref.current!.className = 'oculta' } }>
                            <span>
                            <img alt="Descargar" src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgGif" />
                            <br></br>
                            <span style={{fontSize:'36px'}} >
                                Decarga <span className="text-danger">Finalizada</span>
                            </span>
                            <br></br>
                            <br></br>
                            
                            <br></br>
                            </span>
                        </a>
                        
                    </div>
                </div>     
                
                
                
                
                
                
                
                
                
                
                <div className="row align-items-end mt-4">
                    <div className="col-12 col-md-4 text-center">
                        <button type="button" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' + ( refBtnGenDescICV.current?.disabled ? '' : 'invisible' ) } 
                            onClick={ e => { window.location.href = '/wps/portal/infonavitmx/mx2/derechohabientes/el_instituto/sii' } }
                            >Regresar</button>
                    </div>
                    <div className="col-12 col-md-4 text-center">
                        <span className={ fileReady ? 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' : 'oculta' } onClick={ e => { e.preventDefault(); ahref.current?.click()} }>Exportar descarga
                        	&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                        	<img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgBtn" />
                        </span>
                    </div>
                    <div className="col-12 col-md-4 text-center">
                        <button type="reset" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0    ' + ( refBtnGenDescICV.current?.disabled ? '' : 'invisible' ) } 
                            onClick={ () => {
                                /*setDescargando(false);
                                setFileReady(false);
                                if ( refBtnGenDescICV && refBtnGenDescICV.current ) refBtnGenDescICV.current.disabled = false ;*/
                                nuevaConsulta();
                            }}
                            >Nueva consulta</button>
                    </div>
                </div>
                
                
                
                
                
                
                
                
                                                                       

            </div>
            <div className="col-12 mt-1">
                <div className="row">
                    <div className="col-12 mt-4 text-center">
                        <button ref={ refBtnGenDescICV } type="button" className={" btn btn-rojo button-rojo mt-3 mt-md-0 " + ( refBtnGenDescICV.current?.disabled ? 'invisible' : '' )} onClick={ handleSubmit }>Generar descarga</button>
                    </div>
                </div>
            </div>
            </form>
            
            {
                error !== '' && <Modal toggle={toggle} mensaje={ error} />
            }
        </div>
    );



    

    
}